import { render, staticRenderFns } from "./IngresoCalidad.vue?vue&type=template&id=beac2d46&scoped=true"
import script from "./IngresoCalidad.vue?vue&type=script&lang=js"
export * from "./IngresoCalidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac2d46",
  null
  
)

export default component.exports